// src/globalErrorHandlers.ts

import { createBaseErrorPayload, uploadClientError } from "./stdlib-errors";

export function installGlobalErrorHandlers(): void {
    window.addEventListener("error", event => {
        void uploadClientError({
            ...createBaseErrorPayload("window-error", event.message),
            name: event.error instanceof Error ? event.error.name : undefined,
            stack: event.error instanceof Error ? event.error.stack : undefined,
            source: event.filename || undefined,
            line: event.lineno || undefined,
            column: event.colno || undefined
        });
    });

    window.addEventListener("unhandledrejection", event => {
        const reason = event.reason;

        if (reason instanceof Error) {
            void uploadClientError({
                ...createBaseErrorPayload("unhandled-rejection", reason.message),
                name: reason.name,
                stack: reason.stack
            });

            return;
        }

        void uploadClientError({
            ...createBaseErrorPayload("unhandled-rejection", String(reason))
        });
    });
}